// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"601":"9ee31b38","924":"0458e288"}[chunkId] + ".css";
};